// Manager Approve — a custom-body popup (see DynamicPopup's config.component
// escape hatch). It renders the FinanceApprovalPanel (submissionManager)
// instead of a field form, so there is no `fields`/`okText` here. Admin lists
// this by its popupKey "manager-approve" and tags it to a module's Approve
// action.
import ManagerApproveBody from './ManagerApproveBody.jsx';

export const config = {
  title: 'Manager Approve',
  width: 780,
  className: 'fa-modal manager-approve-modal',
  component: ManagerApproveBody,
};
